import React from 'react';
import Careers from '../components/Careers';

const CareersPage = () => {
  return (
    <>
      <Careers />
    </>
  );
};

export default CareersPage;
